import { useState, useMemo, ReactNode } from "react";
import {
  PublicUserOrganization,
  OrganizationProjectsQuery,
} from "../../__generated__/graphql";
import { DashboardContext } from "./context";

type Project = OrganizationProjectsQuery["projects"][number];

interface DashboardProviderProps {
  children: ReactNode;
}

export function DashboardProvider({ children }: DashboardProviderProps) {
  const [selectedUsers, setSelectedUsers] = useState<PublicUserOrganization[]>(
    []
  );
  const [selectedProjects, setSelectedProjects] = useState<Project[]>([]);

  const value = useMemo(
    () => ({
      selectedUsers,
      setSelectedUsers,
      selectedProjects,
      setSelectedProjects,
    }),
    [selectedUsers, selectedProjects]
  );

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
}
